const Announcements = () => import("./views/Announcements.vue");
const AnnouncementEdit = () => import("./views/AnnouncementEdit.vue");

const route = "/announcements";

export default [
  {
    path: route,
    name: "announcements.list",
    component: Announcements,

    meta: {
      roles: [
        "ROLE_ADMIN",
        "ROLE_INSTITUTIONS_ADMIN",
        "ROLE_PARENT",
        "ROLE_INSTITUTION_WORKER",
        "ROLE_COOK",
      ],
    },
  },

  {
    path: `${route}/create`,
    name: "announcements.create",
    component: AnnouncementEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:announcementId/edit`,
    name: "announcements.edit",
    component: AnnouncementEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
